import React, { useState } from "react";
import KairosChat_L1 from "./KairosChat_L1";
import KairosChat_L3 from "./KairosChat_L3";
import PreIntake_L3 from "./PreIntake_L3";
import Home from "./Home";
import "./App.css";

function App() {
  const [page, setPage] = useState("home");
  // home | l1 | l3 | pre_l3

  return (
    <div className="App">

      <div className="page-container">

        {page === "home" && (
          <Home
            onStartL1={() => setPage("l1")}          // bypass L1
            onStartL3={() => setPage("l3")}          // bypass L3
            onPreIntake={() => setPage("pre_l3")}    // filtered L3
          />
        )}

        {page === "pre_l3" && (
          <PreIntake_L3 onPass={() => setPage("l3")} />
        )}

        {page === "l1" && <KairosChat_L1 />}
        {page === "l3" && <KairosChat_L3 />}
      </div>

      <footer className="kairos-footer">
        © The Kairos Method | Proof of Concept
      </footer>

    </div>
  );
}

export default App;
